// resources/assets/js/directives/can.js
import Acl from '../acl'

export default {
    // inserted -> executado na criação do elemento
    inserted(el, binding) {
        const allowed = Acl.can(binding.value)
        // por padrão remove do DOM quando não permitido
        if (!allowed) {
            // remove sem quebrar se não tiver parent
            if (el.parentNode) el.parentNode.removeChild(el)
            else el.style.display = 'none'
        }
    },

    // update -> reage a mudanças de binding (caso dynamic)
    update(el, binding) {
        const allowed = Acl.can(binding.value)
        // se já foi removido, nada a fazer
        if (!el.parentNode) {
            // se não permitido: nada
            // se permitido e quisermos re-inserir, isso é mais complexo (recomendado usar v-show em vez disso)
            return
        }
        el.style.display = allowed ? '' : 'none'
    }
}
